export default axios => ({
  getDocumentsSliced: ({ projectId, payload }) => axios.get(`projects/${projectId}/documents-sliced`, payload)
})